// Cute CSS/SVG kid mascot avatars — shows uploaded photo when `src` is provided
export function KidAvatar({ gender = "Laki-laki", size = 56, className = "", src = null }) {
  if (src) {
    return (
      <img
        src={src}
        alt="Foto siswa"
        className={`rounded-full object-cover ${className}`}
        style={{ width: size, height: size }}
      />
    );
  }
  const girl = gender === "Perempuan";
  const outfit = girl ? "#E8A33D" : "#E0A020";
  return (
    <div
      className={`rounded-full flex items-center justify-center overflow-hidden ${className}`}
      style={{ width: size, height: size, background: "linear-gradient(160deg,#FDF3D8,#F6E2A8)" }}
    >
      <svg viewBox="0 0 64 64" width={size * 0.92} height={size * 0.92}>
        {girl ? (
          <path d="M32 6C20 6 15 16 15 27v8c0 12 8 21 17 21s17-9 17-21v-8C49 16 44 6 32 6z" fill={outfit} />
        ) : null}
        <circle cx="32" cy="30" r="15" fill="#F7C58B" />
        {!girl && <path d="M17 26c0-9 6-15 15-15s15 6 15 15v3l-4-2-3 2-4-2-4 2-4-2-3 2-4-2z" fill="#5A3A1A" />}
        <circle cx="26" cy="30" r="2" fill="#3a2a17" />
        <circle cx="38" cy="30" r="2" fill="#3a2a17" />
        <path d="M27 37c2 2 8 2 10 0" stroke="#b5651d" strokeWidth="2" fill="none" strokeLinecap="round" />
        <path d="M14 52c2-8 9-12 18-12s16 4 18 12z" fill={outfit} />
      </svg>
    </div>
  );
}
